import { useQuery } from '@tanstack/react-query';
import type { SignalDto } from '@terra/shared-contracts-signals';
import { terraProxyApiClient } from '../clients/testerClient';
import { SIGNAL_DETAIL_QUERY_KEY } from './api/useUpdateSignal';

interface UseSignalDetailOptions {
  signalId: string | undefined;
  enabled?: boolean;
}

export function useSignalDetail({
  signalId,
  enabled = true,
}: UseSignalDetailOptions) {
  const query = useQuery({
    queryKey: [SIGNAL_DETAIL_QUERY_KEY, signalId],
    queryFn: async (): Promise<SignalDto | null> => {
      if (!signalId) {
        return null;
      }
      return terraProxyApiClient.getSignal(signalId);
    },
    enabled: enabled && !!signalId,
    staleTime: 30000,
    gcTime: 60000,
  });

  return {
    signal: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
